/**
 * PROTOTYPE CONTENT — NOT VERIFIED. Restored verbatim from `design-reference/`.
 * Several of these lines assert a trading history the company does not have yet
 * ("Six months old", "Six contracts", "Forty-one people"), and the positioning
 * they imply is still open in `company/POSITIONING.md`. See CONTENT-STATUS.md.
 */
export const copy = {
  home: {
    headline: 'Civil infrastructure, built by people who have done it before.',
    sub: 'Based in Burgersfort, on the Eastern Limb of the Bushveld Complex. Earthworks, roads, bulk water and mine civils — self-performed across Limpopo, Mpumalanga and Gauteng.',
    capabilityHeading: 'Six disciplines, one delivery team.',
    capabilityBlurb:
      'We self-perform the majority of our work, which means schedule and quality stay in our hands.',
    workHeading: 'Projects on the ground',
    safetyHeading: 'Zero harm is a schedule item, not a slogan.',
    safetyBlurb:
      'Forty-six thousand site hours since March and not one lost-time injury. Every Samloryx site runs a documented OHS Act Section 37(2) agreement, daily hazard briefings and an independent monthly audit.',
  },
  about: {
    headline: 'Six months old. Built by people who are not.',
    valuesHeading: 'What we hold ourselves to',
    valuesBlurb: 'Four commitments we intend to still be keeping in ten years.',
    leadershipTeaser: 'Four directors. No layer between them and the site.',
  },
  leadership: {
    headline: 'The four people who sign off on every contract.',
  },
  safety: {
    headline: 'Nobody goes home injured. From day one, that is the only acceptable outcome.',
    systemHeading: 'The system on every site',
    certHeading: 'Certification & legal compliance',
  },
  services: {
    headline: 'Six disciplines, self-performed.',
    sub: 'Most contracts draw on more than one. We run them as one team under one programme, with our own crews on the critical path.',
  },
  sectors: {
    headline: 'Five markets we are building a record in.',
  },
  projects: {
    headline: 'Six contracts. Every one from our first year.',
  },
  careers: {
    headline: 'Build a career on real sites.',
    sub: 'Forty-one people, one head office in Burgersfort and work across three provinces. We are hiring the people who will decide how this company works for the next twenty years.',
    applyConfirmation:
      'Every application is read by a director within ten working days. If shortlisted you will be contacted for a technical interview in Burgersfort or on site.',
  },
  news: {
    headline: 'Everything that has happened so far.',
  },
  contact: {
    headline: 'One head office in Burgersfort, and a number that gets answered.',
    /** Split so the inline link renders where the prototype had it. */
    formBlurbBefore:
      'For tender documents, supplier registration or media enquiries. If you have a project to price, the ',
    formBlurbLink: 'quote request',
    formBlurbAfter: ' gets to the estimating team faster.',
  },
  quote: {
    headline: 'Tell us about the project.',
    sub: 'Three short steps. Estimating responds within two working days with a scope confirmation and an indicative range.',
    submittedHeading: 'Request received.',
    submittedBody:
      'Reference SLX-Q-2026-0418. A senior estimator will contact you within two working days. If the project is on a tender clock, call +27 11 468 2200 and quote the reference.',
    /** Split so the address renders in mono, as it did in the prototype. */
    attachmentsBefore:
      'Drawings, bills of quantities or a scope document speed things up considerably. Email them to ',
    attachmentsEmail: 'tenders@samloryx.co.za',
    attachmentsAfter: ' with your reference once you submit.',
  },
} as const

/** Options offered in the quote wizard. */
export const quoteOptions = {
  workTypes: [
    'Roads & bridges',
    'Building works',
    'Mining civils',
    'Water & sanitation',
    'Energy & electrical',
    'Turnkey / PM',
  ],
  budgets: ['< R10 m', 'R10–50 m', 'R50–250 m', 'R250 m–1 bn', '> R1 bn'],
  provinces: [
    'Gauteng',
    'KwaZulu-Natal',
    'Western Cape',
    'Eastern Cape',
    'Limpopo',
    'Mpumalanga',
    'North West',
    'Free State',
    'Northern Cape',
  ],
  starts: ['Within 3 months', '3–6 months', '6–12 months', 'Beyond 12 months', 'Feasibility only'],
  contractForms: [
    'Not yet decided',
    'NEC3 / NEC4 ECC',
    'JBCC Principal Building Agreement',
    'FIDIC',
    'GCC 2015',
    'Bespoke',
  ],
}

/** Subject options on the contact form. */
export const contactSubjects = [
  'General enquiry',
  'Supplier / subcontractor registration',
  'Tender documentation',
  'Media & communications',
  'Careers',
]

/** Empty-state line in the header search overlay. */
export const searchEmptyState = 'No matches. Try “roads”, “mining”, “water”, “Gauteng”.'
